import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "image-operation"
};
import { Delete, View, Download } from '@element-plus/icons-vue';
import { toRefs, watch } from 'vue';
import { onMounted, ref } from 'vue';
import { Markmap } from 'markmap-view';
import { Transformer } from 'markmap-lib';
import download from '@/utils/download';
import { ElLoading } from 'element-plus';
import { useMessage } from '@/hooks/web/useMessage';
export default /*@__PURE__*/_defineComponent({
  __name: 'ItemCard',
  props: {
    detail: {
      type: Object,
      require: true
    }
  },
  emits: ['onBtnClick', 'onMjBtnClick'],
  setup(__props, {
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    const props = __props;
    const svgRef = ref();
    let markMap = null;
    const transformer = new Transformer();
    const cardImageRef = ref(); // 卡片 image ref
    const emits = __emit; // emits
    /** 处理点击事件  */
    const handleButtonClick = async (type, detail) => {
      emits('onBtnClick', type, detail);
    };
    /** 监听详情 */
    const {
      detail
    } = toRefs(props);
    // 监听内容变化并重新渲染
    watch(() => props.detail?.generatedContent, () => {
      renderMindMap();
    });
    // 渲染思维导图
    const renderMindMap = () => {
      try {
        if (!props.detail?.generatedContent) return;
        // 转换Markdown为思维导图数据
        const {
          root
        } = transformer.transform(props.detail.generatedContent);
        // 设置数据并适配视图
        markMap?.setData(root);
        markMap?.fit();
      } catch (e) {
        console.error('渲染思维导图失败:', e);
      }
    };
    /** 初始化 */
    onMounted(async () => {
      if (!props.detail?.generatedContent) {
        return;
      }
      // 初始化思维导图
      if (svgRef.value) {
        markMap = Markmap.create(svgRef.value, {
          autoFit: true,
          // 自动适配内容
          fitRatio: 0.8,
          // 适配比例
          paddingX: 20 // 水平内边距
        });
        renderMindMap();
      }
    });
    /** 下载图片：download SVG to png file */
    // const downloadImage = () => {
    //   const svgElement = cardImageRef.value
    //   // 将 SVG 渲染到图片对象
    //   const serializer = new XMLSerializer()
    //   const source = `<?xml version="1.0" standalone="no"?>\r\n${serializer.serializeToString(svgRef.value!)}`
    //   const base64Url = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(source)}`
    //   download.image({
    //     url: base64Url,
    //     canvasWidth: svgElement?.offsetWidth,
    //     canvasHeight: svgElement?.offsetHeight,
    //     drawWithImageSize: false
    //   })
    // }
    const downloadImage = () => {
      if (!svgRef.value) {
        message.error('无法获取思维导图内容');
        return;
      }
      // 显示加载提示
      const loadingInstance = ElLoading.service({
        lock: true,
        text: '正在生成图片，请稍候...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        // 获取 SVG 元素的实际尺寸
        const svgElement = svgRef.value;
        const rect = svgElement.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(svgElement);
        // 获取实际渲染尺寸
        const svgSvgElement = svgElement;
        const width = svgSvgElement.viewBox?.baseVal?.width || rect.width || parseInt(computedStyle.width) || 800;
        const height = svgSvgElement.viewBox?.baseVal?.height || rect.height || parseInt(computedStyle.height) || 600;
        // 获取所有样式表
        const styleSheets = Array.from(document.styleSheets);
        let cssText = '';
        try {
          styleSheets.forEach(sheet => {
            try {
              const rules = Array.from(sheet.cssRules || sheet.rules || []);
              rules.forEach(rule => {
                // 只包含与 markmap 相关的样式
                if (rule.cssText && (rule.cssText.includes('markmap') || rule.cssText.includes('mm-'))) {
                  cssText += rule.cssText + '\n';
                }
              });
            } catch (e) {
              // 忽略跨域样式表错误
            }
          });
        } catch (e) {
          console.warn('无法获取样式表:', e);
        }
        // 序列化 SVG
        const serializer = new XMLSerializer();
        let source = serializer.serializeToString(svgElement);
        // 添加必要的命名空间和属性
        if (!source.includes('xmlns=')) {
          source = source.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
        }
        if (!source.includes('xmlns:xlink')) {
          source = source.replace('<svg', '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
        }
        // 设置明确的宽高
        if (!source.includes('width=')) {
          source = source.replace('<svg', `<svg width="${width}" height="${height}"`);
        }
        // 如果有样式，添加到 SVG 中
        if (cssText) {
          const styleTag = `<style><![CDATA[${cssText}]]></style>`;
          source = source.replace('>', `>${styleTag}`);
        }
        // 添加 XML 声明
        source = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n${source}`;
        console.log('SVG 数据准备完成，开始下载...', {
          width,
          height,
          hasStyles: !!cssText
        });
        // 关闭加载提示
        loadingInstance.close();
        // 显示处理提示
        message.info('正在处理下载，请稍候...');
        // 使用优化后的 SVG 转 PNG 方法
        download.svgToPng({
          svgData: source,
          fileName: 'mindmap.png',
          width: Math.round(width),
          height: Math.round(height)
        });
        // 延迟显示成功消息（给下载一些时间）
        setTimeout(() => {
          message.success('下载已开始，如果未自动下载请检查浏览器设置');
        }, 1000);
      } catch (error) {
        // 关闭加载提示
        loadingInstance.close();
        console.error('下载图片失败:', error);
        message.error('下载失败，请稍后重试');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        "body-class": "",
        class: "image-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
          class: "w-[150px] mb-2",
          truncated: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(detail)?.prompt), 1)]),
          _: 1
        })]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(Download),
          onClick: downloadImage
        }, null, 8, ["icon"]), _createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(Delete),
          onClick: _cache[0] || (_cache[0] = $event => handleButtonClick('delete', _unref(detail)))
        }, null, 8, ["icon"]), _createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(View),
          onClick: _cache[1] || (_cache[1] = $event => handleButtonClick('view', _unref(detail)))
        }, null, 8, ["icon"])])]), _createElementVNode("div", {
          class: "image-wrapper",
          ref_key: "cardImageRef",
          ref: cardImageRef
        }, [(_openBlock(), _createElementBlock("svg", {
          ref_key: "svgRef",
          ref: svgRef,
          class: "w-full",
          style: {
            height: '160px'
          }
        }, null, 512))], 512)]),
        _: 1
      });
    };
  }
});